import React from 'react';
import { Switch, Route, Link, Redirect, withRouter } from 'react-router-dom';
// import HomepageSliderGrid from './HomepageSliderGrid';
import { TransitionGroup, Transition, CSSTransition } from 'react-transition-group';
import { randomInt } from "../modules/RandomInt";
import DeviceManager from "../modules/DeviceManager";
import { TweenLite, Expo, Bounce, Elastic, Power2, scrollTo } from "gsap/all";
import 'intersection-observer';

import AuTateProjectGrid from './AuTateProjectGrid';
import DoolitleProjectGrid from './DoolitleProjectGrid';
import MortOuVifProjectGrid from './MortOuVifProjectGrid';
import RatpProjectGrid from './RatpProjectGrid';
import RenaultProjectGrid from './RenaultProjectGrid';
import TelegraphProjectGrid from './TelegraphProjectGrid';
import ValsalvaProjectGrid from './ValsalvaProjectGrid';
import WetProjectGrid from './WetProjectGrid';

class HomepageProjectsSlider extends React.Component {
    constructor(props) {
        super(props);

        this.prevProjectLink = null;
        this.nextProjectLink = null;
        this.scrollObserver = null;
        this.currentProjectName = null;

        this.stickOffset = 0;
        // this.isFirstLoad = true;
        this.projectsCount = this.props.projects.length - 1;
        this.isFirefox = DeviceManager.isFirefox();
        this.isEdge = DeviceManager.isEdge();

        this.previousProject = {
            name: '',
            path: ''
        };
        this.nextProject = {
            name: '',
            path: ''
        };
        this.currentProject = {
            name: '',
            author: {
                name: '',
                job: ''
            }
        };

        // this.onClick = this.onClick.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.prevProjectLinkCallback = this.prevProjectLinkCallback.bind(this);
        this.nextProjectLinkCallback = this.nextProjectLinkCallback.bind(this);
        this.refreshProjectLinksOffsets = this.refreshProjectLinksOffsets.bind(this);
        this.onProjectNameClick = this.onProjectNameClick.bind(this);
        this.onProjectNameRef = this.onProjectNameRef.bind(this);
        this.onProjectNameHover = this.onProjectNameHover.bind(this);
        this.onProjectNameOut = this.onProjectNameOut.bind(this);
        this.stickProjectNameToTop = this.stickProjectNameToTop.bind(this);
        this.updateStickOffset = this.updateStickOffset.bind(this);
        this.onPageLeave = this.onPageLeave.bind(this);
    }

    componentDidMount() {
        this.updateStickOffset();

        window.addEventListener('resize', this.refreshProjectLinksOffsets);
        window.addEventListener('resize', this.updateStickOffset);
        window.addEventListener('scroll', this.stickProjectNameToTop);
        
        // this.scrollObserver = new IntersectionObserver((entries, observer) => {
        //     entries.forEach((entry) => {
        //         if(entry.isIntersecting) {
        //             if(entry.intersectionRatio === 1) {
        //                 if(!document.body.classList.contains('disable-project-rollover')) {
        //                     document.body.classList.add('disable-project-rollover');
        //                 }
        //             }
        //             else {
        //                 if(document.body.classList.contains('disable-project-rollover') && entry.boundingClientRect.y > 0) {
        //                     document.body.classList.remove('disable-project-rollover');
        //                 }
        //             }
        //             // this.scrollObserver.unobserve(entry.target);
        //         }
        //     });
        // }, {
        //     threshold: 1.0,
        //     rootMargin: '0px'
        // });

        // this.observeProjectName();
    }

    componentDidUpdate() {
        this.refreshProjectLinksOffsets();
        this.updateStickOffset();
        // this.onClick();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.refreshProjectLinksOffsets);
        window.removeEventListener('resize', this.updateStickOffset);
        window.removeEventListener('scroll', this.stickProjectNameToTop);

        // if(this.scrollObserver && this.currentProjectName) {
        //     this.scrollObserver.unobserve(this.currentProjectName)
        // }
    }

    stickProjectNameToTop() {
        if(this.currentProjectName) {
            if(window.pageYOffset > window.innerHeight + this.stickOffset) {
                if(!this.currentProjectName.classList.contains('fixed')) {
                    this.currentProjectName.classList.add('fixed');
                }
            }
            else {
                if(this.currentProjectName.classList.contains('fixed')) {
                    this.currentProjectName.classList.remove('fixed');
                }
            }
        }
    }

    updateStickOffset() {
        if(this.currentProjectName) {
            this.stickOffset = 0;
            
            if(this.currentProject.hasMultilineTitle) {
                let wW = window.innerWidth;

                if(wW >= 1024 && wW < 1200) {
                    this.stickOffset = 135;
                }
                else if(wW >= 1200 && wW < 2300) {
                    this.stickOffset = 165;
                }
                else if(wW >= 2300) {
                    this.stickOffset = 340;
                }
            }
        }
    }

    refreshProjectLinksOffsets() {
        let wW = window.innerWidth;
        let prevOffset = this.previousProject.offset.small;
        let nextOffset = this.nextProject.offset.small;

        if(wW >= 1200) {
            prevOffset = this.previousProject.offset.medium;
            nextOffset = this.nextProject.offset.medium;
        }
        else if(wW >= 2300) {
            prevOffset = this.previousProject.offset.large;
            nextOffset = this.nextProject.offset.large;
        }

        if(this.prevProjectLink) {
            TweenLite.set(this.prevProjectLink, {xPercent: prevOffset, x: 0});
        }

        if(this.nextProjectLink) {
            TweenLite.set(this.nextProjectLink, {xPercent: nextOffset, x: 0});
        }
    }

    prevProjectLinkCallback(node) {
        this.prevProjectLink = node;
        this.refreshProjectLinksOffsets();
    }

    nextProjectLinkCallback(node) {
        this.nextProjectLink = node;
        this.refreshProjectLinksOffsets();
    }

    findProject(path) {
        const cleanedPath = path.replace(/\//g, '');
        let currentProjectIndex = this.props.projects.findIndex(project => project.path === cleanedPath);

        if(currentProjectIndex === -1) {
            currentProjectIndex = randomInt(0, this.props.projects.length - 1);
        }

        let previousProjectIndex = 0;
        let nextProjectIndex = 0;

        if(currentProjectIndex + 1 <= this.projectsCount) {
            nextProjectIndex = currentProjectIndex + 1;
        }
        else {
            nextProjectIndex = 0;
        }

        if(currentProjectIndex - 1 >= 0) {
            previousProjectIndex = currentProjectIndex - 1;
        }
        else {
            previousProjectIndex = this.projectsCount;
        }

        // Current project data
        this.currentProject.name = this.props.projects[currentProjectIndex].name;
        this.currentProject.hasMultilineTitle = this.props.projects[currentProjectIndex].hasMultilineTitle;
        this.currentProject.class = this.currentProject.name.replace(/ /g, '-').toLowerCase();
        this.currentProject.prevRollover = this.props.projects[currentProjectIndex].prevRollover;
        this.currentProject.nextRollover = this.props.projects[currentProjectIndex].nextRollover;
        this.currentProject.author.name = this.props.projects[currentProjectIndex].author.name;
        this.currentProject.author.job = this.props.projects[currentProjectIndex].author.job;
        this.currentProject.author.complement = this.props.projects[currentProjectIndex].author.name.split(' ')[0];
        this.currentProject.gridImages = this.props.projects[currentProjectIndex].gridImages;
        
        // Previous project data
        this.previousProject.name = this.props.projects[previousProjectIndex].name;
        this.previousProject.path = this.props.projects[previousProjectIndex].path;
        this.previousProject.offset = this.props.projects[currentProjectIndex].prevOffset;

        // Next project data
        this.nextProject.name = this.props.projects[nextProjectIndex].name;
        this.nextProject.path = this.props.projects[nextProjectIndex].path;
        this.nextProject.offset = this.props.projects[currentProjectIndex].nextOffset;
    }

    // onClick(e) {
    //     let target = e.target;
    //     TweenLite.to(target, 0.2, {scaleX: 1.2, scaleY: 0.4, transformOrigin: 'bottom center', ease: Expo.easeOut});
    //     TweenLite.to(target, 0.8, {scaleX: 1, scaleY: 1, delay: 0.2, ease: Elastic.easeOut});
    // }

    onMouseEnter(e) {
        TweenLite.to(e.target, 0.4, {scaleX: 1.2, scaleY: 0.95, transformOrigin: 'bottom center', ease: Expo.easeOut});
    }

    onMouseLeave(e) {
        TweenLite.to(e.target, 0.4, {scaleX: 1, scaleY: 1.1, transformOrigin: 'bottom center', ease: Bounce.easeOut});
    }

    // onClick() {
    //     // setTimeout(() => {
    //     //     document.body.classList.add('on-next-project');
    //     // }, 0);
    //     // setTimeout(() => {
    //     //     document.body.classList.remove('on-next-project');
    //     // }, 1200);
    // }

    onProjectNameClick() {
        if(window.pageYOffset < 51) {
            TweenLite.to(window, 0.5, {scrollTo: '.current-project-name', ease: Power2.easeOut});
        }
        else {
            TweenLite.to(window, 0.5, {scrollTo: {x: 0, y: 0}, ease: Power2.easeOut});
        }
    }

    onProjectNameHover() {
        if(window.pageYOffset < 50) {
            TweenLite.to(window, 0.5, {scrollTo: {x: 0, y: 50}, ease: Power2.easeOut});
        }
    }

    onProjectNameOut() {
        if(window.pageYOffset <= 51) {
            TweenLite.to(window, 0.5, {scrollTo: {x: 0, y: 0}, ease: Power2.easeOut});
        }
    }

    onProjectNameRef(node) {
        if(node) {
            this.currentProjectName = node;
        }
    }

    onPageLeave(path) {
        TweenLite.to(window, 0.5, {scrollTo: {x: 0, y: 0}, ease: Power2.easeOut, onComplete: () => {
            this.props.history.push(`/${path}`);
        }});
    }
    
    // observeProjectName() {
    //     if(this.currentProjectName) {
    //         this.scrollObserver.observe(this.currentProjectName);
    //     }
    // }

    render() {
        // Redirect homepage url to match a project grid url
        if(this.props.location.pathname === '/') {
            return <Redirect to={this.props.projects[randomInt(0, this.props.projects.length - 1)].path} />;
        }

        this.findProject(this.props.location.pathname);

        return (
            <TransitionGroup>
                    <CSSTransition key={this.props.location.key} in={true} appear={true} timeout={{ enter: 800, exit: 1200 }} classNames={'test'}>
            <div className={`${this.currentProject.class}-project-grid homepage-projects-slider desktop`}>
                <svg className="project-infos-svg" width="205" height="215" viewBox="0 0 205 215">
                    <defs>
                        <clipPath id="project-name-clip">
                            <polygon points="0,0 155,0 0,215" fill="#000"/>
                        </clipPath>
                        <clipPath id="project-author-clip">
                            <polygon points="155,0 205,128 0,214" fill="#fff"/>
                        </clipPath>
                        <clipPath id="project-author-clip2">
                            <polygon points="155,0 -273,218 53,234" fill="#fff" style={{transform: `rotate(-23deg)`}}/>
                        </clipPath>
                    </defs>
                    <rect x="0" y="0" width="215" height="215" fill="#fff" clipPath="url(#project-author-clip)"/>
                    <text className="barlow-it project-author-fill" x="142.7" y="69" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. `).repeat(5)}</text>
                    <text className="barlow-it project-author-fill" x="141" y="84" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. ${this.currentProject.author.complement}`).repeat(5)}</text>
                    <text className="barlow-it project-author-fill" x="142" y="99" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. `).repeat(5)}</text>
                    <text className="barlow-it project-author-fill" x="141" y="114" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. ${this.currentProject.author.complement}`).repeat(5)}</text>
                    <text className="barlow-it project-author-fill" x="142" y="129" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. `).repeat(5)}</text>
                    <text className="barlow-it project-author-fill" x="141" y="144" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. ${this.currentProject.author.complement}`).repeat(5)}</text>
                    <text className="barlow-it project-author-fill" x="141" y="159" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>{(`${this.currentProject.author.name}. `).repeat(5)}</text>
                    <text x="141" y="174" fill="#000" transform={this.isEdge ? 'rotate(-22.3)' : undefined} style={{transform: `rotate(-22.3deg)`}} textAnchor="end" clipPath={((!this.isFirefox && !this.isEdge) ? 'url(#project-author-clip2)' : undefined)}>
                        <tspan className="barlow-it project-author-fill">{(`${this.currentProject.author.name}.`).repeat(5)}</tspan>
                        <tspan className="barlow-bo-it">{' ' + this.currentProject.author.job}.</tspan> 
                    </text>

                    <rect x="0" y="0" width="215" height="215" fill="#000" clipPath="url(#project-name-clip)"/>
                    <text x="1" y="50" fill="#af2100" clipPath="url(#project-name-clip)">
                        <tspan className="barlow-bo-it">Serie. </tspan> 
                        <tspan className="barlow-it project-name-fill">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                    </text>
                    <text className="barlow-it" x="0" y="53" fill="#af2100" clipPath="url(#project-name-clip)">
                        <tspan className="red" x="0" y="64">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                        <tspan className="red" x="0" dy="13.7">{(`${this.currentProject.name}. `).repeat(8)}</tspan>
                    </text>
                </svg>
                
                <TransitionGroup>
                    <CSSTransition key={this.props.location.key} in={true} appear={true} timeout={{ enter: 800, exit: 800 }} classNames={'fade'}>
                    
                        <Switch location={this.props.location}>
                            {/*<Route exact path="/wet" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/valsalva" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/ratp" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/renault" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/mort-ou-vif" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/telegraph" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/doolittle" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />
                            <Route exact path="/au-tate" render={(props) => <HomepageSliderGrid {...props} componentName={props.location.pathname.replace(/\//g, '').replace(/-/g, '')} gridImages={this.currentProject.gridImages} /> } />*/}

                            <Route exact path="/wet" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <WetProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/valsalva" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <ValsalvaProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/ratp" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <RatpProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/renault" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <RenaultProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/mort-ou-vif" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <MortOuVifProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/telegraph" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <TelegraphProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/doolittle" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <DoolitleProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route exact path="/au-tate" render={(props) => {
                                const cleanedPath = props.location.pathname.replace(/\//g, '');
                                return <AuTateProjectGrid {...props} path={cleanedPath} />;
                            }} />
                            <Route render={() => <div>Not Found</div>} />
                        </Switch>
                    </CSSTransition>
                    
                </TransitionGroup>

                <div ref={this.onProjectNameRef} className={`current-project-name project-slider-text red barlow-bl-it noselect ${(this.currentProject.hasMultilineTitle ? 'multiline' : '')}`} onClick={this.onProjectNameClick} onMouseEnter={this.onProjectNameHover} onMouseLeave={this.onProjectNameOut}>{this.currentProject.name}</div>
                
                {/*<Link innerRef={this.prevProjectLinkCallback} to={this.previousProject.path} className="prev-project-name project-slider-text red barlow-bl-it" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>{this.previousProject.name[this.previousProject.name.length-1].toLowerCase()}</Link>*/}
                <div ref={this.prevProjectLinkCallback} className="prev-project-name project-slider-text red barlow-bl-it noselect" onClick={this.onPageLeave.bind(this, this.previousProject.path)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>{this.previousProject.name[this.previousProject.name.length-1].toLowerCase()}</div>
                {this.currentProject.prevRollover === 'line' &&
                    <svg className="rollover-shape rollover-line prev-line" x="0px" y="0px" width="537.3px" height="292.1px" viewBox="0 0 537.3 262.1" style={{letterSpacing: '1.4px'}}>
                        <path id="last-distorted-line2" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M1.4,219.7l15.2,1.9
                            l267.6,40.4l164-5.3"/>
                        <path id="third-distorted-line2" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M1.4,161.7l103.2,26
                            l234.8-13.6"/>
                        <path id="second-distorted-line2" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M2.9,75.8l195.4,37.7
                            L395,84.1l143.3,18.4"/>
                        <path id="first-distorted-line2" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M2.4,36.7l107-11.3
                            l206.7,16.3L506,0.5"/>
                        <text className="barlow-bo-it" fill="#af2100" textAnchor="end">
                            <textPath xlinkHref="#first-distorted-line2" startOffset="100%">Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous.</textPath>
                        </text>
                        <text className="barlow-it" fill="#af2100" textAnchor="end">
                            <textPath xlinkHref="#second-distorted-line2" startOffset="100%">{(`${this.previousProject.name}. `).repeat(19)}</textPath>
                        </text>
                        <text className="barlow-it" fill="#af2100" textAnchor="end">
                            <textPath xlinkHref="#third-distorted-line2" startOffset="100%">{(`${this.previousProject.name}. `).repeat(19)}</textPath>
                        </text>
                        <text className="barlow-bo-it" fill="#af2100" textAnchor="end">
                            <textPath xlinkHref="#last-distorted-line2" startOffset="100%">Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous.</textPath>
                        </text>
                    </svg>
                }
                {this.currentProject.prevRollover === 'arrow' &&
                    <svg className="rollover-shape rollover-arrow prev-arrow" x="0px" y="0px" width="717" height="536" viewBox="0 0 717 536">
                        <defs>
                            <pattern id="previous-pattern" x="0" y="0" width="360" height="22" viewBox="0 0 360 12" patternUnits="userSpaceOnUse">
                                <text className="next-pattern barlow-bo-it" x="1" y="4" fill="#fff">
                                    Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous.
                                </text>
                            </pattern>
                            {/*<pattern id="project-pattern2" x="0" y="0" width="932" height="40" viewBox="0 0 932 20" patternUnits="userSpaceOnUse">*/}
                            <pattern id="project-pattern2" x="0" y="0" width="532" height="40" viewBox="0 0 532 20" patternUnits="userSpaceOnUse">
                                <text className="project-pattern barlow-it" x="0" y="4" fill="#fff">
                                    <tspan x="0" dx="-17" dy="0">{(`${this.previousProject.name}. `).repeat(17)}</tspan>
                                    <tspan x="0" dx="-34" dy="20">{(`${this.previousProject.name}. `).repeat(17)}</tspan>
                                </text>
                            </pattern>
                        </defs>
                        <polygon points="720,0 576,120 720,240" fill="url(#previous-pattern)"/>
                        <polygon points="720,240 576,360 720,480" fill="url(#project-pattern2)"/>
                        
                        <polygon points="432,240 288,360 432,480" fill="url(#previous-pattern)"/>
                        <polygon points="432,0 288,120 432,240" fill="url(#project-pattern2)"/>
                        <polygon points="432,480 360,540 432,540" fill="url(#project-pattern2)"/>
                        
                        <polygon points="144,240 0,360 144,480" fill="url(#project-pattern2)"/>
                        <polygon points="144,0 0,120 144,240" fill="url(#previous-pattern)"/>
                        <polygon points="144,480 72,540 144,540" fill="url(#previous-pattern)"/>
                    </svg>
                }
                {this.currentProject.prevRollover === 'circle' && 
                    <svg className="rollover-shape rollover-circle prev-circle" width="776.4px" height="776.7px" viewBox="0 0 776.4 776.7">
                        <path id="external-circle2" fill="none" strokeMiterlimit="10" d="M118,162.4C182.5,85.3,279.5,36.2,388,36.2
                            c194.4,0,352,157.6,352,352s-157.6,352-352,352c-12,0-23.9-0.6-35.6-1.8"/>
                        <path id="middle-circle2" className="middle-circle2 transform-origin-center" fill="none" d="M253.3,185.9c38.5-25.7,84.8-40.7,134.6-40.7
                            c134.2,0,243,108.8,243,243c0,116.6-82.2,214.1-191.8,237.6"/>
                        <path id="internal-circle2" fill="none" d="M388,207.7c24.4,0,48,4.8,70.3,14.2c21.5,9.1,40.8,22.1,57.4,38.7c16.6,16.6,29.6,35.9,38.7,57.4
                            c9.4,22.3,14.2,45.9,14.2,70.3s-4.8,48-14.2,70.3c-9.1,21.5-22.1,40.8-38.7,57.4c-16.6,16.6-35.9,29.6-57.4,38.7
                            c-22.3,9.4-45.9,14.2-70.3,14.2s-48-4.8-70.3-14.2c-21.5-9.1-40.8-22.1-57.4-38.7c-16.6-16.6-29.6-35.9-38.7-57.4
                            c-9.4-22.3-14.2-45.9-14.2-70.3s4.8-48,14.2-70.3c9.1-21.5,22.1-40.8,38.7-57.4c16.6-16.6,35.9-29.6,57.4-38.7
                            C339.9,212.5,363.6,207.7,388,207.7 M388,206.7c-100.2,0-181.5,81.3-181.5,181.5S287.7,569.7,388,569.7s181.5-81.3,181.5-181.5
                            S488.2,206.7,388,206.7L388,206.7z"/>
                        <text className="circle-text barlow-bo-it text-internal-circle" fill="#af2100">
                            <textPath xlinkHref="#internal-circle2">Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous. Previous.</textPath>
                        </text>
                        <text className="circle-text barlow-it text-middle-circle" textAnchor="middle">
                            <textPath xlinkHref="#middle-circle2" startOffset="40%">{(`${this.previousProject.name}. `).repeat(40)}</textPath>
                        </text>
                        <text className="circle-text barlow-it text-external-circle" textAnchor="middle">
                            <textPath xlinkHref="#external-circle2" startOffset="38.5%">{(`${this.previousProject.name}. `).repeat(40)}</textPath>
                        </text>
                    </svg>
                }

                {/*<Link innerRef={this.nextProjectLinkCallback} to={this.nextProject.path} className="next-project-name project-slider-text red barlow-bl-it" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>{this.nextProject.name[0].toUpperCase()}</Link>*/}
                <div ref={this.nextProjectLinkCallback} className="next-project-name project-slider-text red barlow-bl-it noselect" onClick={this.onPageLeave.bind(this, this.nextProject.path)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>{this.nextProject.name[0].toUpperCase()}</div>
                {this.currentProject.nextRollover === 'circle' &&
                    <svg className="rollover-shape rollover-circle next-circle" width="776.7px" height="776.4px" viewBox="0 0 776.7 776.4">
                        <path id="external-circle" className="external-circle transform-origin-center" fill="none" strokeMiterlimit="10" d="M423.7,738.3c-11.7,1.2-23.6,1.8-35.6,1.8
                            c-194.4,0-352-157.6-352-352s157.6-352,352-352c108.4,0,205.4,49,270,126.1"/>
                        <path id="middle-circle" className="middle-circle transform-origin-center" fill="none" d="M336.9,625.7c-109.6-23.5-191.8-120.9-191.8-237.6
                            c0-134.2,108.8-243,243-243c49.8,0,96.1,15,134.6,40.7"/>
                        <path id="internal-circle" className="internal-circle transform-origin-center" fill="none" d="M388.1,207.6c24.4,0,48,4.8,70.3,14.2c21.5,9.1,40.8,22.1,57.4,38.7c16.6,16.6,29.6,35.9,38.7,57.4
                            c9.4,22.3,14.2,45.9,14.2,70.3s-4.8,48-14.2,70.3c-9.1,21.5-22.1,40.8-38.7,57.4c-16.6,16.6-35.9,29.6-57.4,38.7
                            c-22.3,9.4-45.9,14.2-70.3,14.2s-48-4.8-70.3-14.2c-21.5-9.1-40.8-22.1-57.4-38.7c-16.6-16.6-29.6-35.9-38.7-57.4
                            c-9.4-22.3-14.2-45.9-14.2-70.3s4.8-48,14.2-70.3c9.1-21.5,22.1-40.8,38.7-57.4c16.6-16.6,35.9-29.6,57.4-38.7
                            C340.1,212.4,363.7,207.6,388.1,207.6 M388.1,206.6c-100.2,0-181.5,81.3-181.5,181.5s81.3,181.5,181.5,181.5
                            s181.5-81.3,181.5-181.5S488.3,206.6,388.1,206.6L388.1,206.6z"/>
                        <text className="circle-text barlow-bo-it text-internal-circle" fill="#af2100" transform={((this.isFirefox || this.isEdge) ? 'rotate(71, 386, 386)' : undefined)}>
                            <textPath xlinkHref="#internal-circle">Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next.</textPath>
                        </text>
                        <text className="circle-text barlow-it text-middle-circle" textAnchor="middle" transform={((this.isFirefox || this.isEdge) ? 'rotate(-24, 386, 386)' : undefined)}>
                            <textPath xlinkHref="#middle-circle" startOffset="40%">{(`${this.nextProject.name}. `).repeat(40)}</textPath>
                        </text>
                        <text className="circle-text barlow-it text-external-circle" textAnchor="middle" transform={((this.isFirefox || this.isEdge) ? 'rotate(-17, 386, 386)' : undefined)}>
                            <textPath xlinkHref="#external-circle" startOffset="38.5%">{(`${this.nextProject.name}. `).repeat(40)}</textPath>
                        </text>
                    </svg>
                }
                {this.currentProject.nextRollover === 'arrow' &&
                    <svg className="rollover-shape rollover-arrow next-arrow" x="0px" y="0px" width="717" height="536" viewBox="0 0 717 536">
                        <defs>
                            <pattern id="next-pattern" x="0" y="0" width="360" height="22" viewBox="0 0 360 12" patternUnits="userSpaceOnUse">
                                <text className="next-pattern barlow-bo-it" x="1" y="4" fill="#fff">
                                    Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next.
                                </text>
                            </pattern>
                            <pattern id="project-pattern" x="0" y="0" width="432" height="40" viewBox="0 0 432 20" patternUnits="userSpaceOnUse">
                                <text className="project-pattern barlow-it" x="0" y="4" fill="#fff">
                                    <tspan x="0" dx="-17" dy="0">{(`${this.nextProject.name}. `).repeat(17)}</tspan>
                                    <tspan x="0" dx="-34" dy="20">{(`${this.nextProject.name}. `).repeat(17)}</tspan>
                                </text>
                            </pattern>
                        </defs>
                        <polygon points="0,0 144,120 0,240" fill="url(#next-pattern)"/>
                        <polygon points="0,240 144,360 0,480" fill="url(#project-pattern)"/>
                        
                        <polygon points="288,240 432,360 288,480" fill="url(#next-pattern)"/>
                        <polygon points="288,0 432,120 288,240" fill="url(#project-pattern)"/>
                        <polygon points="288,480 360,540 288,540" fill="url(#project-pattern)"/>
                        
                        <polygon points="576,240 720,360 576,480" fill="url(#project-pattern)"/>
                        <polygon points="576,0 720,120 576,240" fill="url(#next-pattern)"/>
                        <polygon points="576,480 648,540 576,540" fill="url(#next-pattern)"/>
                    </svg>
                }
                {this.currentProject.nextRollover === 'line' &&
                    <svg className="rollover-shape rollover-line next-line" x="0px" y="0px" width="537.3px" height="292.1px" viewBox="0 0 537.3 262.1" style={{letterSpacing: '1.4px'}}>
                        <path id="last-distorted-line" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M91.5,256.6l164,5.3
                                L523,221.6l15.2-1.9"/>
                        <path id="third-distorted-line" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M200.3,174.1L435,187.7
                                l103.2-26"/>
                        <path id="second-distorted-line" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M1.4,112.5l143.3-18.4
                                l196.7,29.4l195.4-37.7"/>
                        <path id="first-distorted-line" fillRule="evenodd" clipRule="evenodd" fill="none" strokeMiterlimit="10" d="M33.7,0.5l189.9,41.2
                                l206.7-16.3l107,11.3"/>

                        <text className="barlow-bo-it" fill="#af2100" textAnchor="start">
                            <textPath xlinkHref="#first-distorted-line" startOffset="0%">Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next.</textPath>
                        </text>
                        <text className="barlow-it" fill="#af2100" textAnchor="start">
                            <textPath xlinkHref="#second-distorted-line" startOffset="0%">{(`${this.nextProject.name}. `).repeat(19)}</textPath>
                        </text>
                        <text className="barlow-it" fill="#af2100" textAnchor="start">
                            <textPath xlinkHref="#third-distorted-line" startOffset="0%">{(`${this.nextProject.name}. `).repeat(19)}</textPath>
                        </text>
                        <text className="barlow-bo-it" fill="#af2100" textAnchor="start">
                            <textPath xlinkHref="#last-distorted-line" startOffset="0%">Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next. Next.</textPath>
                        </text>
                    </svg>
                }
            </div>
            </CSSTransition>
                    
                </TransitionGroup>
        );
    }
}

export default withRouter(HomepageProjectsSlider);


// WEBPACK FOOTER //
// ./src/components/HomepageProjectsSlider.js